import ExamListPageContainer from "../../components/courses/examList";

const ExamList = () => {
  return <ExamListPageContainer />;
};
export default ExamList;
